import React from "react";
import { MsalProvider, useMsal, useIsAuthenticated } from "@azure/msal-react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./authConfig";
import Router from "./components/Router";

const pca = new PublicClientApplication(msalConfig);

// Ensure account is set active on reload for persisted sessions
pca.initialize().then(() => {
  const accounts = pca.getAllAccounts();
  if (accounts.length > 0) {
    pca.setActiveAccount(accounts[0]);
  }
});

function Content() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const login = () => instance.loginPopup(loginRequest);
  const logout = () => instance.logoutPopup();

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          {/* Login Card */}
          <div className="rounded-2xl border border-slate-700/40 bg-gradient-to-br from-slate-800/80 to-slate-900/80 p-8 shadow-2xl backdrop-blur-sm">
            {/* Header */}
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-emerald-500/20 to-blue-500/20 border border-emerald-500/30 mb-6">
                <span className="text-4xl">🍽️</span>
              </div>
              <h1 className="text-3xl font-bold text-white mb-2">
                Lunch Buddy
              </h1>
              <p className="text-slate-300 text-lg">
                Quản lý ăn trưa thông minh
              </p>
              <p className="text-slate-400 text-sm mt-2">
                Đăng nhập để bắt đầu sử dụng
              </p>
            </div>

            {/* Features */}
            <div className="space-y-3 mb-8">
              <div className="flex items-center gap-3 text-slate-300">
                <div className="w-8 h-8 rounded-full bg-emerald-500/20 flex items-center justify-center">
                  <span className="text-sm">🏠</span>
                </div>
                <span className="text-sm">Chọn mang cơm hoặc đặt đồ ăn</span>
              </div>
              <div className="flex items-center gap-3 text-slate-300">
                <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center">
                  <span className="text-sm">👥</span>
                </div>
                <span className="text-sm">Tham gia phiên đặt đồ ăn cùng team</span>
              </div>
              <div className="flex items-center gap-3 text-slate-300">
                <div className="w-8 h-8 rounded-full bg-purple-500/20 flex items-center justify-center">
                  <span className="text-sm">📊</span>
                </div>
                <span className="text-sm">Theo dõi tổng quan thời gian thực</span>
              </div>
            </div>

            {/* Login Button */}
            <button
              onClick={login}
              className="w-full rounded-xl bg-gradient-to-r from-emerald-500 to-blue-500 hover:from-emerald-600 hover:to-blue-600 text-white font-bold text-lg py-4 px-6 transition-all duration-300 hover:scale-105 active:scale-95 shadow-lg shadow-emerald-500/25"
            >
              <div className="flex items-center justify-center gap-3">
                <span className="text-2xl">🚀</span>
                Đăng nhập với Microsoft
              </div>
            </button>

            {/* Footer */}
            <div className="text-center mt-6">
              <p className="text-xs text-slate-400">
                Sử dụng tài khoản Microsoft của bạn
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Router 
      userEmail={accounts[0]?.username} 
      displayName={accounts[0]?.name}
      onLogout={logout}
    />
  );
}

function WebApp() {
  return (
    <MsalProvider instance={pca}>
      <Content />
    </MsalProvider>
  );
}

export default WebApp;


